import React from 'react';
import EmpowermentVisionBG from '../assets/EmpowermentVisionBG.png';
import EmpowermentVisionLOGO from '../assets/EmpowermentVisionLOGO.png';

export default function EmpowermentVision() {
  return (
    <section className="py-16 px-4 w-full bg-[#f8f9fa]">
      <div className="max-w-7xl mx-auto flex flex-col items-center">
        
        {/* Header Section */}
        <div className="text-center mb-12">
          <p className="text-[#0056b3] text-[14px] font-bold tracking-widest uppercase mb-4">
            The Empowerment Vision
          </p>
          <h2 className="text-[60px] md:text-5xl font-bold text-[#111827] leading-tight">
            More Than Beauty <br />
            We Build <span className="text-[#0056b3] italic">Confidence</span>, Careers <br />
            & Community
          </h2>
        </div>

        {/* Image and Glassmorphism Card Container */}
        <div className="relative w-full mb-28 md:mb-36">
          
          <div className="w-full h-[400px] md:h-[500px] rounded-3xl overflow-hidden shadow-lg">
            <img
              src={EmpowermentVisionBG}
              alt="Diverse group of smiling people"
              className="w-full h-full object-cover object-top" 
            />
          </div>

          {/* Glassmorphism Overlay Card */}
          <div className="absolute left-1/2 -translate-x-1/2 -bottom-20 md:-bottom-10 w-[95%] md:w-[80%] max-w-4xl bg-white/70 backdrop-blur-md border border-white/50 rounded-3xl p-6 md:p-10 shadow-2xl text-center z-10">
            
            {/* Logo */}
            <div className="flex justify-center mb-4 md:mb-6">
              <img
                src={EmpowermentVisionLOGO}
                alt="Inner Crown Foundation Logo"
                className="h-16 md:h-24 w-auto object-contain"
              />
            </div>

            {/* Description Text */}
            <p className="text-gray-800 text-sm md:text-base leading-relaxed mb-6 md:mb-8 max-w-3xl mx-auto">
              The Inner Crown Foundation is a women-led nonprofit based in Oregon dedicated to
              uplifting survivors, children, single parents, and low-income families. Our purpose is
              simple and deeply human: to ensure every individual has the confidence, safety, and
              support they need to rebuild their life with dignity and hope.
            </p>

            {/* CTA Button */}
            <button onClick={() => window.open("https://innercrown.org/", "_blank")} className="bg-[#0056b3] text-white px-8 py-3 rounded-full font-medium text-sm hover:bg-blue-800 transition-colors inline-flex items-center gap-2">
              VISIT SITE
              <svg 
                className="w-4 h-4" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}